'use strict';

exports.builtin = [
  require('../plugins/preset-default.js'),
  require('../plugins/addAttributesToSVGElement.js'),
  require('../plugins/addClassesToSVGElement.js'),
  require('../plugins/cleanupAttrs.js'),
  require('../plugins/cleanupEnableBackground.js'),
  require('../plugins/cleanupIds.js'),
  require('../plugins/cleanupListOfValues.js'),
  require('../plugins/cleanupNumericValues.js'),
  require('../plugins/collapseGroups.js'),
  require('../plugins/convertColors.js'),
  require('../plugins/convertEllipseToCircle.js'),
  require('../plugins/convertOneStopGradients.js'),
  require('../plugins/convertPathData.js'),
  require('../plugins/convertShapeToPath.js'),
  require('../plugins/convertStyleToAttrs.js'),
  require('../plugins/convertTransform.js'),
  require('../plugins/mergeStyles.js'),
  require('../plugins/inlineStyles.js'),
  require('../plugins/mergePaths.js'),
  require('../plugins/minifyStyles.js'),
  require('../plugins/moveElemsAttrsToGroup.js'),
  require('../plugins/moveGroupAttrsToElems.js'),
  require('../plugins/prefixIds.js'),
  require('../plugins/removeAttributesBySelector.js'),
  require('../plugins/removeAttrs.js'),
  require('../plugins/removeComments.js'),
  require('../plugins/removeDesc.js'),
  require('../plugins/removeDimensions.js'),
  require('../plugins/removeDoctype.js'),
  require('../plugins/removeEditorsNSData.js'),
  require('../plugins/removeElementsByAttr.js'),
  require('../plugins/removeEmptyAttrs.js'),
  require('../plugins/removeEmptyContainers.js'),
  require('../plugins/removeEmptyText.js'),
  require('../plugins/removeHiddenElems.js'),
  require('../plugins/removeMetadata.js'),
  require('../plugins/removeNonInheritableGroupAttrs.js'),
  require('../plugins/removeOffCanvasPaths.js'),
  require('../plugins/removeRasterImages.js'),
  require('../plugins/removeScriptElement.js'),
  require('../plugins/removeStyleElement.js'),
  require('../plugins/removeTitle.js'),
  require('../plugins/removeUnknownsAndDefaults.js'),
  require('../plugins/removeUnusedNS.js'),
  require('../plugins/removeUselessDefs.js'),
  require('../plugins/removeUselessStrokeAndFill.js'),
  require('../plugins/removeViewBox.js'),
  require('../plugins/removeXlink.js'),
  require('../plugins/removeXMLNS.js'),
  require('../plugins/removeXMLProcInst.js'),
  require('../plugins/reusePaths.js'),
  require('../plugins/sortAttrs.js'),
  require('../plugins/sortDefsChildren.js'),
];
